import { render, staticRenderFns } from "./SelectPlanBtn.vue?vue&type=template&id=929f0b34&"
import script from "./SelectPlanBtn.vue?vue&type=script&lang=js&"
export * from "./SelectPlanBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports